window.CNAM_FO = {
    nouvelleFenetreVers : "Nouvelle fenêtre vers "
}